import React from 'react';
import { ArrowRight } from 'lucide-react';
import { realExample, marketingImages } from '../../data/mock';

const RealExample = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {realExample.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A realistic roadmap showing exactly what to expect
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start max-w-6xl mx-auto">
          {/* Timeline */}
          <div className="space-y-8">
            {realExample.phases.map((phase, idx) => (
              <div key={idx} className="relative">
                {/* Connector Line */}
                {idx < realExample.phases.length - 1 && (
                  <div className="absolute left-6 top-14 w-0.5 h-full bg-teal-200"></div>
                )}
                
                <div className="flex gap-4">
                  {/* Step Number */}
                  <div className="w-12 h-12 rounded-full bg-teal-500 flex items-center justify-center flex-shrink-0 text-white font-bold text-lg z-10">
                    {idx + 1}
                  </div>
                  
                  {/* Content */}
                  <div className="flex-1 bg-gray-50 rounded-2xl p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {phase.phase}
                    </h3>
                    <ul className="space-y-2 mb-4">
                      {phase.details.map((detail, i) => (
                        <li key={i} className="text-gray-600 text-sm flex items-start gap-2">
                          <ArrowRight className="w-4 h-4 text-teal-500 flex-shrink-0 mt-0.5" />
                          {detail}
                        </li>
                      ))}
                    </ul>
                    <div className="bg-teal-500 text-white px-4 py-2 rounded-lg inline-block font-bold">
                      Total: {phase.total}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Image */}
          <div className="flex justify-center lg:sticky lg:top-32">
            <img 
              src={marketingImages.chapterPreview} 
              alt="Chapter Preview"
              className="w-full max-w-md rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RealExample;
